<template>
  <!-- 协同 -->
  <!-- 协同 -->
  <!-- 协同 -->
  <div>
    <el-dialog
      title="协同人"
      :visible.sync="dialogShow"
      width="50%"
      :fullscreen="dialogFull"
      :close-on-click-modal="false"
      :before-close="handleClose"
      append-to-body
      :modal-append-to-body="false"
    >
    <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        协同人
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                        <el-divider></el-divider>
                </template>
      <avue-form
        :option="settingSynergyOption"
        v-model="form"
        @submit="formSubmit"
        id="actionForm"
      >
        <!-- 协同班组slot ↓  -->
        <template slot="group">
          <!-- case hasGroups -->
          <el-select
            v-if="hasGroups"
            placeholder="请选择 协同班组"
            v-model="form.group"
            @change="groupChange"
          >
            <el-option
              v-for="item in groupList"
              :key="item.value"
              :label="item.groupName"
              :value="item.groupId"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
          <!-- case noneGroups -->
          <el-select v-if="!hasGroups" disabled v-model="groupName">
            <el-option :value="groupName" :label="groupName"> </el-option>
          </el-select>
        </template>
        <!-- 协同人slot ↓  -->
        <template slot="cooperateList">
          <div>
            <el-select
            id="selectCooperate"
              :placeholder="choosenList.length>0?'':'请选择 协同人' "
              v-model="form.cooperateList"
              multiple
              ref="select"
              @change="cooperatorsChange"
            >
              <el-option
                v-for="(item, index) in cooperatorList"
                :key="index"
                :label="item.userName"
                :value="item.userId"
                :disabled="item.disabled"
              >
              <div style="position: relative; width: 100%; overflow: hidden; display:flex;">
                <div style="width: 45%; text-align: center;">{{item.realNameAndPhone}}</div>
                <div style="width: 8%; text-align: center;">{{item.workingCondition}}</div>
                <div style="width: 8%; text-align: center;">{{item.currentCount}}</div>
                <div style="width: 39%; text-align: center; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{item.teamRemark.slice(0,20)}}</div>
              </div>
              </el-option>
            </el-select>
            <!-- 已选择列表 -->
            <div class="choosen-list" @click="openSelectPeopleDialpg">
              <span
                class="choosen-item"
                v-for="(item, index) in choosenList"
                :key="index"
              >
                <div class="choosen-item-text">
                  {{ item.userName }}
                </div>
                <div class="choosen-item-icon" @click="removeUser(index)">
                  x
                </div>
              </span>
            </div>
          </div>
        </template>

        <template slot="menuForm">
          <el-button @click="handleClose"
            ><span class="el-icon-close"></span> 取 消</el-button
          >
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>
<script>
import { settingSynergyOption } from "./course-dialog-form-option";
import {
  getGroupDetails,
  getCooperateList,
  setCooperate,
  getGroupUser,
  getGroupList,
} from "@/api/crmedical/order/order-list/order-list";
export default {
  data() {
    return {
      dialogFull:false,
      form: {
        cooperateList: [],
      },
      userList: [],
      cooperatorList: [],
      dialogShow: false,
      settingSynergyOption: settingSynergyOption,
      orderId: "", //工单id
      groupList: [], //班组列表
      groupName: "",
      hasGroups: false,
      choosenList: [],
    };
  },
  methods: {
    openSelectPeopleDialpg(){
      console.log(this.$refs.select)
      this.$refs.select.focus();
      this.$refs.select.toggleMenu();
    },
    // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then(()=> {

                        self.dialogShow = false;

                })
                .catch(()=> {

                });
        },
    openDialog(order) {
      this.orderId = order;
      this.dialogShow = true;
      this.form = {};
      this.form.cooperateList = [];
      this.loadGroupList();
    },
    closeDialog() {
      this.dialogShow = false;
    },
    removeUser(index) {
      this.choosenList.splice(index, 1);
      this.disableChoosenItems();
    },
    //选择
    cooperatorsChange(valuesArray, a) {
      console.log("valuesArray==>", valuesArray, a);
      valuesArray.forEach((id) => {
        let choosenIndex = this.choosenList.findIndex(
          (item) => item.userId == id
        );
        console.log("this==>", this.cooperatorList);
        let listIndex = this.cooperatorList.findIndex(
          (item) => item.userId == id
        );
        console.log(choosenIndex, listIndex);
        if (choosenIndex == -1 && listIndex != -1) {
          this.choosenList.push(this.cooperatorList[listIndex]);
        }
      });
      //
      this.disableChoosenItems();
      this.$set(this.form, "cooperateList", []);
    },
    //切换班组
    groupChange(val) {
      const params = { groupId: val, orderId: this.orderId };
      getGroupUser(params).then((res) => {
        res.data.userList.forEach((ele) => {
          ele.userId = ele.id;
          ele.userName = ele.realName;
        });
        this.cooperatorList = res.data.userList;
        this.disableChoosenItems();
      });
    },
    //已选禁用
    disableChoosenItems() {
      this.cooperatorList.forEach((item) => {
        let index = this.choosenList.findIndex((c) => c.userId == item.userId);
        item.disabled = index != -1;
      });
    },
    //获取班组列表
    loadGroupList() {
      const params = { orderId: this.orderId };
      getGroupList(params).then((res) => {
        //这里可以合并,待优化
        if (res.data.length) {
          //查到多个班组,通过班组切换获取协同人列表
          this.hasGroups = true;
          this.groupList = res.data;
          getCooperateList({ orderId: this.orderId }).then((res) => {
            this.choosenList = res.data;
            //回显当前协同人名字
            getGroupDetails({ orderId: this.orderId })
              .then((res2) => {
                res2.data.userList.forEach((ele) => {
                  ele.userId = ele.id;
                  ele.userName = ele.realName;
                });
                this.form.group = res2.data.name;
                this.cooperatorList = res2.data.userList;
                this.disableChoosenItems();
                console.log("this.cooperatorList==>", this.cooperatorList);
              })
              .catch((e) => {
                console.log("e==>", e);
              });
          });
        } else {
          //没查到(直接从工单id获取协同人列表)
          this.hasGroups = false;
          getCooperateList({ orderId: this.orderId }).then((res) => {
            this.choosenList = res.data;
            getGroupDetails({ orderId: this.orderId }).then((res) => {
              res.data.userList.forEach((ele) => {
                ele.userId = ele.id;
                ele.userName = ele.realName;
                // if (this.checkChoosen(ele.id)) {
                //   ele.disabled = true;
                // }
              });
              this.groupName = res.data.name;
              this.cooperatorList = res.data.userList;
              this.disableChoosenItems();
            });
          });
        }
      });
    },
    formSubmit(form, done) {
      let postData = {};
      let postUser = [];
      this.choosenList.forEach((item) => {
        postUser.push({
          userId: item.userId,
          userName: item.userName,
        });
      });
      if (this.choosenList.length == 0) {
        this.$message.error("请选择协同人");
        done();
        return;
      }
      postData = {
        cooperateList: postUser,
        orderId: this.orderId,
      };
      setCooperate(postData)
        .then((res) => {
          done();
          if (res.msg == "操作成功") {
            this.$message.success(res.msg);
            this.dialogShow = false;
          } else {
            this.$message.error(res.msg);
          }
          this.$emit("handleClose", function () {
            console.log("关闭历程表");
          });
        })
        .catch((err) => {
          done();
          console.log("err==>", err);
        });
    },
  },
};
</script>
<style lang="scss">
#actionForm {
  .choosen-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    font-size: 12px;
    position: absolute;
    top: 0px;
    left: 0px;
    border: 1px solid #DCDFE6;
    border-radius: 5px;
    width: 100%;
    min-height: 30px;
    align-items: center;
    .choosen-item {
      margin: 2px;
      padding: 0 5px;
      border-radius: 5px;
      background-color: #f4f4f5;
      border: 1px solid #e9e9eb;
      color: #909399;
      display: flex;
      align-items: center;
      .choosen-item-icon {
        background-color: #c0c4cc;
        height: 12px;
        line-height: 9px;
        text-align: center;
        width: 12px;
        border-radius: 50%;
        margin-left: 5px;
        cursor: pointer;
      }
    }
    span {
      height: 20px;
      line-height: 20px;
    }
  }
}
#selectCooperate {
    border: none !important;
}
</style>

